import { render, staticRenderFns } from "./TopCategory.vue?vue&type=template&id=0ee04bd4&scoped=true&"
import script from "./TopCategory.vue?vue&type=script&lang=js&"
export * from "./TopCategory.vue?vue&type=script&lang=js&"
import style0 from "./TopCategory.vue?vue&type=style&index=0&id=0ee04bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee04bd4",
  null
  
)

export default component.exports